import axios, {AxiosError, AxiosResponse} from 'axios'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import configData from '../config/config.json'
import {notificationActions} from "../common/store/notification.state"

export interface CustomAxiosError {
    readonly message: string
    readonly code?: number
}

export interface ErrorResponse {
    message: string
    payload?: any
}

const axiosInstance = axios.create({
    baseURL: `${configData.SERVER_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const reqInterceptor = (config: any) => {
    const token = localStorage.getItem('token')

    if (token) {
        if (!config.headers) {
            config.headers = {}
        }
        config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
}

const resInterceptor = (response: AxiosResponse) => {
    return response
}

const errInterceptor = (error: AxiosError) => {
    return Promise.reject(error)
}

const requestInterceptor = axiosInstance.interceptors.request.use(
    reqInterceptor,
    errInterceptor
)

const responseInterceptor = axiosInstance.interceptors.response.use(
    resInterceptor,
    errInterceptor
)

const ejectInterceptors = () => {
    axiosInstance.interceptors.request.eject(requestInterceptor)
    axiosInstance.interceptors.response.eject(responseInterceptor)
}

// @ts-ignore
const AxiosInterceptor = ({children}) => {
    const dispatch = useDispatch()

    useEffect(() => {
        const errorInterceptor = async (
            error: AxiosError<ErrorResponse | Blob>
        ) => {
            let message = 'Errore'

            const responseData = error.response?.data

            if (responseData instanceof Blob) {
                try {
                    const text = await responseData.text()

                    if (text) {
                        const data = JSON.parse(text) as ErrorResponse

                        message =
                            data.message ||
                            'Errore durante la richiesta.'
                    }
                } catch {
                    message = 'Errore durante la richiesta.'
                }
            } else if (
                responseData &&
                typeof responseData === 'object'
            ) {
                message =
                    responseData.message ||
                    'Errore durante la richiesta.'
            }

            dispatch(
                notificationActions.error({
                    code: error.response ? error.response.status : 500,
                    message
                })
            )

            return Promise.reject(error)
        }

        axiosInstance.interceptors.response.use(
            resInterceptor,
            errorInterceptor
        )

        return () => {
            ejectInterceptors()
        }
    }, [dispatch])

    return children
}

export default axiosInstance
export {AxiosInterceptor}
